import { render } from "./create-account-links.vue?vue&type=template&id=36b42d89&ts=true"
import script from "./create-account-links.vue?vue&type=script&lang=ts"
export * from "./create-account-links.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__